import {
  CITRUS_AD_PROVIDER,
  CITRUS_FOP_ATTRIBUTE,
  CITRUS_ADS_BETA_FEATURE,
} from '../constants';

export const getCitrusAdData = ({ fopAttributes = {}, betaFeatures = [], shouldReport }) => {
  const isEnabled = shouldReport || isCitrusAdEnabled(betaFeatures);
  if (isEnabled && (CITRUS_FOP_ATTRIBUTE in fopAttributes)) {
    return {
      adId: fopAttributes[CITRUS_FOP_ATTRIBUTE],
      provider: CITRUS_AD_PROVIDER,
    };
  }

  return null;
};

export const isCitrusAdEnabled = (betaFeatures = []) => betaFeatures.includes(CITRUS_ADS_BETA_FEATURE);

export const isCitrusAdProvider = (provider) => provider === CITRUS_AD_PROVIDER;
